var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "186px",
    height: "186px",
    viewBox: "0 0 186 186",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 90,
    cy: 90,
    r: 90
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#70B8CB",
    strokeWidth: 3,
    cx: 90,
    cy: 90,
    r: 91.5,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    transform: "translate(35 31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1637736 113.946792L4.30981132 128.594717C2.73396226 129.453962 1.31773585 130.510189 0 131.661509c15.6566038 13.201133 35.8675472 21.165283 57.9498113 21.165283 21.9192453 0 42.0011321-7.845283 57.6135847-20.866415-1.44-1.215849-3.002264-2.309434-4.734339-3.172075l-28.7558495-14.376227c-3.7154717-1.857735-6.0622641-5.654717-6.0622641-9.808301V93.3215094c.8083019-.9203773 1.7320755-2.1022641 2.7203774-3.4981132 3.9192452-5.535849 6.8841509-11.625283 8.9388679-18.0135849 3.6883019-1.1377358 6.405283-4.5441509 6.405283-8.5924528V51.1743396c0-2.6490566-1.1784906-5.0162264-3.0090566-6.6735849V27.0916981S94.6426415 0 57.9532075 0C21.2637736 0 24.84 27.0916981 24.84 27.0916981v17.4090566c-1.8339623 1.6573585-3.0090566 4.0245283-3.0090566 6.6735849v12.0430189c0 3.1720755 1.6675472 5.9637736 4.1637736 7.5769811 3.0090566 13.0992453 10.8883019 22.5271698 10.8883019 22.5271698v11.0037736c-.0033963 4.007547-2.1973585 7.699245-5.7192453 9.621509z",
    fill: "#8ED9EA",
    fillRule: "nonzero",
    opacity: 0.17041016
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 58,
    cy: 63,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70B8CB",
    fillRule: "nonzero",
    d: "M68 65.1521739h-7.6849593V73h-3.5914635v-7.8478261H49v-3.3418972h7.7235772V54h3.5914635v7.8102767H68z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.c9886f7d58d984cbfa5dcfd46902475a.svg";
export { ForwardRef as ReactComponent };